import * as userApi from '@/api/user/index';
import * as notificationService from "../notification/index";
import i18n from "@/i18n";
import { ChangePasswordEmailDTO, ChangePasswordTokenDTO, GenericMessage } from '@/api/user/types';


export async function resetPassword(userInfo: string) {
  let message = null;
  try {
    message = (await userApi.resetPassword(userInfo)).data;
    return message.message;
  } catch (err) {
    notificationService.addErrorNotification(
      i18n.t("notifications.error.message") as string
    );
  };
}

export async function changePassword(changePasswordEmail: ChangePasswordEmailDTO) {
  let message = null;
  try {
    message = (await userApi.changePassword(changePasswordEmail)).data;
    notificationService.addSuccessNotification(message!.message);
    return message.message;
  } catch (err) {
    if (err.response && err.response.status === 406) {
      notificationService.addErrorNotification(
        i18n.t("notifications.error.user-change-password-incorrect-message") as string
      );
      return;
    }
    notificationService.addErrorNotification(
      i18n.t("notifications.error.user-change-password-message") as string
    );
  };
}

export async function savePassword(changePasswordToken: ChangePasswordTokenDTO) {
  let message = null;
  try {
    message = (await userApi.savePassword(changePasswordToken)).data;
    notificationService.addSuccessNotification(message!.message);
    return message.message;
  } catch (err) {
    if (err.response && err.response.status === 412) {
      notificationService.addErrorNotification(
        i18n.t("notifications.error.user-save-password") as string
      );
      return;
    }
    notificationService.addErrorNotification(
      i18n.t("notifications.error.message") as string
    );
  };
}


export async function generateSecretKey(companyId: string) {
  try {
    return await userApi.generateSecretKey(companyId)
  } catch (err) {
    if (err.response) {
      if (err.response.status === 404) {
        notificationService.addErrorNotification(
          i18n.t("notifications.error.generate-secret-key-error") as string
        );
      }

      if (err.response.status >= 500) {
        notificationService.addErrorNotification(
          i18n.t("notifications.error.generate-secret-key-other-error") as string
        );
      }
    }
    throw err;
  }
}
